import React from "react";
import { Link, useLocation } from "react-router-dom";
import { buildLeasesUrl } from "../../services/buildUrl.js";
import { ChromeTab } from "../../components/ObjectChrome.jsx";

export function LeasesSubNav() {
  const location = useLocation();
  const timeline = location.pathname.replace(/\/$/, "") === "/leases/timeline" ||
    new URLSearchParams(location.search).get("collection") === "timeline";
  const params = new URLSearchParams(location.search);
  params.delete("view");
  params.delete("tab");
  params.delete("collection");
  params.delete("peek");
  return (
    <nav aria-label="Leases views" data-testid="leases-subnav" className="object-subnav-tabs">
      {[["list", "Leases"], ["timeline", "Timeline"]].map(([view, label]) => {
        const active = timeline === (view === "timeline");
        return (
          <ChromeTab as={Link} active={active}
            key={view}
            data-testid={`toggle-${view}`}
            to={`${buildLeasesUrl(view)}${params.size ? `?${params}` : ""}${location.hash}`}
            state={{ ...location.state, leasesPortfolio: view === "list" }}
            aria-current={active ? "page" : undefined}
          >{label}</ChromeTab>
        );
      })}
    </nav>
  );
}
